// @flow

import React from 'react'
import './App.css'
import Api from './Api'
import AnimatedState from './AnimatedState'
import Blog from './Blog'
import Clock from './Clock'
import ClickCounter from './ClickCounter'
import DropdownItem from './Navbar/DropdownItem'
import DropdownMenu from './Navbar/DropdownMenu'
import Events from './Events'
import HoverCounter from './HoverCounter'
import InputCounter from './InputCounter'
import Navbar from './Navbar'
import Navitem from './Navbar/Navitem'
import PersonClass from './PersonClass'
import PersonHook from './PersonHook'
import StyledComponent from './StyledComponent'
import Test from './Test'
import ToDoApp from './ToDoApp'
import ToDos from './ToDos/ToDos.js'
import Wordpress from './Wordpress'
import WordGame from './WordGame'
import Greeting from './Greeting'
import { ErrorBoundary } from 'react-error-boundary'

import bucketicon from './Navbar/icons/bucket.svg'
import plusicon from './Navbar/icons/plus.svg'
import avataricon from './Navbar/icons/avatar.svg'
import dropdownicon from './Navbar/icons/dropdown.svg'

const ErrorFallback = ({ error }) => (
  <div>
    <p>Something went wrong</p>
    <pre>{error.message}</pre>
  </div>
)

const App = () => {
  return (
    <div className="App">
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Navbar>
          <Navitem icon={plusicon} link="#" />
          <Navitem icon={avataricon} link="#" />
          <Navitem icon={bucketicon} link="#" />
          <Navitem icon={dropdownicon} link="#">
            <DropdownMenu>
              <DropdownItem>another link</DropdownItem>
            </DropdownMenu>
          </Navitem>
        </Navbar>
        <br />
        <br />
        <hr />
        <WordGame />
        <hr />
        <h3>Wordpress Graphql</h3>
        <Wordpress />
        <br />
        <br />
        <hr />
        <h3>Test</h3>
        <Test />
        <br />
        <br />
        <hr />
        <h3>Events</h3>
        <Events />
        <br />
        <hr />
        <h3>Style Components</h3>
        <br />
        <StyledComponent />
        <br />
        <br />
        <hr />
        <h3>Animated State</h3>
        <AnimatedState />
        <br />
        <br />
        <hr />
        <h3>Click Counter</h3>
        <ClickCounter name={'You'} />
        <br />
        <hr />
        <h3>Hover Counter</h3>
        <HoverCounter />
        <br />
        <div className="pad-box">
          <InputCounter label={'Name'} />
        </div>
        <br />
        <br />
        <hr />
        <h3>Blog</h3>
        <Blog />
        <br />
        <br />
        <hr />
        <h3>Api</h3>
        <Api />
        <br />
        <br />
        <hr />
        <h3>Greeting</h3>
        <Greeting subject={{ id: 0, name: 'John' }} />
        <br />
        <br />
        <hr />
        <h3>Person PersonClass</h3>
        <PersonClass />
        <br />
        <br />
        <hr />
        <h3>Person Hook</h3>
        <PersonHook />
        <br />
        <br />
        <hr />
        <h3>To Dos - with State</h3>
        <ToDoApp />
        <br />
        <br />
        <hr />
        <h3>Clock</h3>
        <Clock />
        <br />
        <br />
        <hr />
        <h3>To dos - Redux</h3>
        <ToDos />
        <br />
        <br />
      </ErrorBoundary>
    </div>
  )
}

export default App
